import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

export const Overline = ({ children, className = "" }) => (
  <span className={`font-mono text-[11px] tracking-[0.3em] uppercase text-[var(--gold)] ${className}`}>
    {children}
  </span>
);

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.1, ease: EASE, delay }}
    >
      {children}
    </motion.span>
  </span>
);

export const MaskLineInView = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      whileInView={{ y: "0%" }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 1, ease: EASE, delay }}
    >
      {children}
    </motion.span>
  </span>
);

export const PageHeader = ({ overline, title, intro }) => (
  <header className="relative z-10 px-6 md:px-12 lg:px-16 pt-32 md:pt-44 pb-12 md:pb-16 border-b border-black/10">
    <Reveal><Overline>{overline}</Overline></Reveal>
    <Reveal delay={0.08}>
      <h1 className="mt-6 font-serif font-light text-4xl sm:text-6xl lg:text-7xl tracking-tight leading-[0.95] max-w-4xl text-balance">
        {title}
      </h1>
    </Reveal>
    {intro && (
      <Reveal delay={0.16}>
        <p className="mt-6 text-[var(--text-secondary)] text-lg leading-relaxed max-w-2xl">{intro}</p>
      </Reveal>
    )}
  </header>
);

